"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuScene = void 0;
const Scene_1 = require("./Scene");
const settings_1 = require("../config/settings");
class MenuScene extends Scene_1.Scene {
    constructor(app, sceneManager, gameManager) {
        super(app, sceneManager, gameManager, settings_1.Settings.whiteColor);
        this.musicVolume = settings_1.Settings.loudMusicVolume;
    }
    enterScene(from, target) {
        const _super = Object.create(null, {
            enterScene: { get: () => super.enterScene }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const top = _super.enterScene.call(this, from, target);
            this.colorBackground();
            return top;
        });
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.gameManager.adManager.init();
            yield _super.init.call(this);
        });
    }
    colorBackground() {
        // This is a fix for phones that have a "gap" at the bottom
        const t = '#' + settings_1.Settings.whiteColor.toString(16);
        const b = '#' + settings_1.Settings.statsColor.toString(16);
        if (this.isLandscapeBox) {
            const nav = settings_1.Settings.navHeight;
            document.body.style.background = `linear-gradient(to right, ${b} calc(${nav}px + env(safe-area-inset-left)), ${t} calc(${nav}px + env(safe-area-inset-left))) fixed`;
        }
        else {
            document.body.style.background = `linear-gradient(to bottom, ${t} 50%, ${b} 50%) fixed`;
        }
    }
    layout() {
        super.layout();
        if (!this.isDeinited) {
            this.colorBackground();
        }
    }
}
exports.MenuScene = MenuScene;
